module.exports = __webpack_public_path__ + "img/shiffle-tracks-button.7e189aa3.png";